<div class="drag-preview">
  <span>
    <mydocma-custom-mat-icon
      *ngIf="dragContext?.canDrop; else noDrop"
      class="material-icons-outlined icon-drop calibration-drag-preview-icon"
      [iconName]="'_crosshairs'"
    ></mydocma-custom-mat-icon>
    <ng-template #noDrop>
      <mat-icon class="material-icons-outlined icon-no-drop">block</mat-icon>
    </ng-template>
    <span class="drag-preview__number" *ngIf="pinNumber && dragContext?.canDrop">{{ pinNumber }}</span>
  </span>
</div>
